const VALID_ISRAELI_MOBILE_PREFIXES = new Set([
  "050",
  "051",
  "052",
  "053",
  "054",
  "055",
  "057",
  "058",
]);

export function isValidIsraeliMobilePhone(phone: string): boolean {
  if (!/^\d{10}$/.test(phone)) {
    return false;
  }
  const prefix = phone.slice(0, 3);
  const subscriberFirstDigit = phone[3];
  return (
    VALID_ISRAELI_MOBILE_PREFIXES.has(prefix) && subscriberFirstDigit !== "0"
  );
}

export function getPhoneErrorAfterChange(
  value: string
): boolean | null {
  if (value.length === 10) {
    return !isValidIsraeliMobilePhone(value);
  }
  if (value.length === 0) {
    return false;
  }
  return null;
}
